import {
  IChotDuLieuRequest,
  IChuyenLopChiTietRequest,
  IChuyenLopSinhViensRequest,
  IQuyetDinhChuyenLop,
  IQuyetDinhChuyenLopFilterRequest,
  ITrangThaiHocKyFilterRequest,
} from "../../model/respone/phan-lop-chuyen-nganh/IPhanLopChuyenNganh";
import { apiClient } from "../apiClient";

const TRANG_THAI_API = "stu-trang-thai-hoc-ky";
const QUYET_DINH_API = "quyet-dinh-chuyen-lop";

export const stuTrangThaiHocKyApi = {
  SelectByPhamVi: (request: ITrangThaiHocKyFilterRequest) =>
    apiClient.post(`${TRANG_THAI_API}/select-by-pham-vi`, request),
  PreviewChot: (request: IChotDuLieuRequest) => apiClient.post(`${TRANG_THAI_API}/chot/preview`, request),
  Chot: (request: IChotDuLieuRequest) => apiClient.post(`${TRANG_THAI_API}/chot`, request),
  SetLock: (ids: number[], is_locked: boolean) =>
    apiClient.post(`${TRANG_THAI_API}/set-lock`, { ids, is_locked }),
  Deletes: (ids: number[]) => apiClient.post(`${TRANG_THAI_API}/deletes`, { ids }),
};

export const quyetDinhChuyenLopApi = {
  SelectByKy: (request: IQuyetDinhChuyenLopFilterRequest) =>
    apiClient.post(`${QUYET_DINH_API}/select-by-ky`, request),
  SelectChiTiet: (id_qd: number) => apiClient.get(`${QUYET_DINH_API}/${id_qd}/chi-tiet`),
  SelectSinhVienKhaDung: (id_qd: number, id_he: number, khoa_hoc: number) =>
    apiClient.post(`${QUYET_DINH_API}/sinh-vien-kha-dung`, { id_qd, id_he, khoa_hoc }),

  Insert: (payload: IQuyetDinhChuyenLop) => apiClient.post(QUYET_DINH_API, payload),
  Update: (payload: IQuyetDinhChuyenLop) => apiClient.put(QUYET_DINH_API, payload),
  Delete: (id_qd: number) => apiClient.delete(`${QUYET_DINH_API}/${id_qd}`),

  AddChiTiets: (request: IChuyenLopChiTietRequest) => apiClient.post(`${QUYET_DINH_API}/chi-tiet/adds`, request),
  UpdateLopMoi: (request: IChuyenLopChiTietRequest) =>
    apiClient.post(`${QUYET_DINH_API}/chi-tiet/update-lop-moi`, request),
  ChuyenLop: (request: IChuyenLopSinhViensRequest) => apiClient.post(`${QUYET_DINH_API}/chuyen-lop`, request),
  ThuHoi: (request: IChuyenLopSinhViensRequest) => apiClient.post(`${QUYET_DINH_API}/thu-hoi`, request),

  ReadAndValidateImport: (payload: any) => apiClient.post(`${QUYET_DINH_API}/import/read-and-validate`, payload),
  Import: (payload: any) => apiClient.post(`${QUYET_DINH_API}/import`, payload),
};
